import React from "react";
import { Typography, TypographyProps, Box, Divider } from "@mui/material";

type DtHeaderLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" ;

interface DtHeaderProps {
  level?: DtHeaderLevel;
  children: React.ReactNode;
  sx?: TypographyProps["sx"];
  align?: TypographyProps["align"];
  gutterBottom?: boolean;
  color?: TypographyProps["color"];
  icon?: React.ReactNode;
  divider?: boolean;
  actions?: React.ReactNode; // <-- Add actions prop
}

const DtHeader: React.FC<DtHeaderProps> = ({
  level = "h6",
  children,
  sx,
  align,
  gutterBottom = false,
  color,
  icon,
  divider = false,
  actions, // <-- Accept actions
}) => (
  <Box>
    <Box display="flex" alignItems="center">
      {icon && <Box mr={1}>{icon}</Box>}
      <Typography
        variant={level}
        component={
          level === "subtitle1"
            ? "span"
            : level // "h1"-"h6" are valid HTML tags
        }
        sx={{ flex: 1, ...(level === "subtitle1" ? { fontWeight: 500 } : {}), ...sx }}
        align={align}
        gutterBottom={gutterBottom}
        color={color}
      >
        {children}
      </Typography>
      {actions && <Box ml={1}>{actions}</Box>}
    </Box>
    {divider && <Divider sx={{ mt: 1 }} />}
  </Box>
);

export { DtHeader };